<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Affaires rapportées</h1>
                    <p>Gestion des rapporteur d'affaire</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

                <div class="actions">
                    <ul>
                        <!--<li><button><span>Importer</span></button></li>-->
                        <!--<li v-if="$aclInterfaceValidator('weeboxcore.person.import')"><button @click="importFile()"><span>Importer</span></button></li>
                        <li v-if="$aclInterfaceValidator('weeboxcore.person.export')"><button @click="exportFile()"><span>Export xls</span></button></li>-->
                        <!--<li v-if="$aclInterfaceValidator('weeboxserevita.person.create')">-->
                        <li>
                           <button-action  type="create"/>
                        </li>
                    </ul>
                </div>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :active-date-filter="true" :active-advanced-filter="false" :active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div></div>
                        <div v-bind:class="[ paginator.sort == 'firstname' ? 'active' : '', paginator.order ]">
                            <span data-sort="firstname" @click="setOrder($event)">Nom complet</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'firstname' ? 'active' : '', paginator.order ]">
                            <span data-sort="firstname" @click="setOrder($event)">Nom complet</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'date_start' ? 'active' : '', paginator.order ]">
                            <span data-sort="date_start" @click="setOrder($event)">Date début</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'date_end' ? 'active' : '', paginator.order ]">
                            <span data-sort="date_end" @click="setOrder($event)">Date fin</span>
                        </div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.protractor.clientable.firstname" class="icon icon-icon_company"></i>
                                <i v-if="item.protractor.clientable.firstname" class="icon icon-icon_person"></i>
                            </figure>
                        </div>
                        <div data-field="firstname">
                            <strong>{{ item.protractor.clientable.name }}</strong>
                            <p>{{ item.protractor.code }}</p>
                        </div>
                        <div data-field="firstname">
                            <strong>{{ item.protractor_child.clientable.name }}</strong>
                            <p>{{ item.protractor_child.code }}</p>
                        </div>
                        <div data-field="date_start">
                            <datetime v-model="item.date_start" :human="false" :use-local-tz="false"/>
                        </div>
                        <div data-field="date_end">
                            <datetime v-model="item.date_end" :human="false" :use-local-tz="false"/>
                        </div>
                        <div class="actions">
                            <ul>
                                <li v-show="$aclInterfaceValidator('weeboxserevita.protractorlink.delete', item.id)">
                                    <button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-show="$aclInterfaceValidator('weeboxserevita.protractorlink.update', item.id)">
                                    <button @click="edit(item.id)"><icon name="pencil-02"/></button>
                                </li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ProtractorLinkService from './ProtractorLinkService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ProtractorLinkService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/serevita/protractor-link/Index.vue